import { Suspense } from 'react';
import { Link } from 'react-router-dom';
import { useAtomValue } from 'jotai';
import T from '@wojtekmaj/react-t';

import { Wrapper } from './plan_subscription_issues_banner.styles';

import useAccountPermission from '../../../hooks/useAccountPermission';

import { currentPlanSubscriptionState } from '../../../store';

function PlanSubscriptionIssuesBannerContent() {
  const currentPlanSubscription = useAtomValue(currentPlanSubscriptionState);

  const canViewInvoices = useAccountPermission('invoices_view');

  if (!currentPlanSubscription || !currentPlanSubscription.has_issues) {
    return null;
  }

  const hasPaymentProvider = currentPlanSubscription.billing_provider?.type === 'stripe';

  const contactUsLink = (
    <Link to="#contact-us">
      <T>contact us</T>
    </Link>
  );

  const invoicesLink = (
    <Link to="/settings/invoices">
      <T>your invoices</T>
    </Link>
  );

  return (
    <Wrapper>
      <p>
        <T>Your subscription needs attention and some app features may be impacted.</T>{' '}
        {canViewInvoices && hasPaymentProvider ? (
          <T contactUsLink={contactUsLink} invoicesLink={invoicesLink}>
            {
              'Please check {invoicesLink}. If you still have questions, you can always {contactUsLink}.'
            }
          </T>
        ) : canViewInvoices ? (
          <T contactUsLink={contactUsLink}>
            {'If you have any questions, you can always {contactUsLink}.'}
          </T>
        ) : (
          <T>Please contact the business owner for guidance.</T>
        )}
      </p>
    </Wrapper>
  );
}

export default function PlanSubscriptionIssuesBanner() {
  return (
    <Suspense fallback={null}>
      <PlanSubscriptionIssuesBannerContent />
    </Suspense>
  );
}
